// DARK DROPDOWNS MANAGER

document.querySelectorAll('.k-dark-dropdown').forEach(item => {
    item.addEventListener('click', event => {
        document.querySelector('.select2-dropdown').classList.add("k-dark-dropdown-select2");
    })
});  

// UNIT INPUTS MANAGER
document.querySelectorAll('.k-unit-input').forEach(item => {
    item.addEventListener("keyup", function(){
        var value = $(this).val();
        value = value.replace(/[^A-Za-z0-9]+/g, '');
        $(this).val(value);
    });
});

// S-INPUTS TOOLTIP MANAGER
document.querySelectorAll('.k-s-input').forEach(item => {
    item.addEventListener("focus", function(){
        this.parentElement.parentElement.classList.add("k-s-error-display");
    });
    item.addEventListener("blur", function(){
        this.parentElement.parentElement.classList.remove("k-s-error-display");
    });
});


const _PREFAB = 0, _VALIDATOR = 1, _CUSTOM = 2;
class KukunInput {
    /**
     *
     * @param {HTMLElement|Element} InputContainer - HTMLElement with the input container where it will be evaluated.
     * @param {object} parameters - Object with a set of parameters. It cannot be undefined.
     * @param {"flat"|"classic"} parameters.type - Kukuns input type
     * @param {('email'|'phone'|'url')} [parameters.prefabName] - Name of a prefabricated input validator.
     * @param {PrefabErrors} parameters.errors - Object with multiple HTMLElements depending on the case.
     * @param {ValidatorParams} [parameters.validator] - A ValidatorParams object. Please refer to Validators.
     * @param {function} [parameters.custom] - Custom function to be executed in isValid() execution. It's recommended
     * to return a Boolean type.
     */
    constructor(InputContainer, parameters) {
        this.container = InputContainer;
        this.parameters = parameters;
        this.type = -1;
        this.input = InputContainer.querySelector("input.k-input, textarea.k-input, input.k-s-input");
        this._addParameters();
        this._loadEvents();
    }

    _loadEvents() {
        { //General event
           /* let that = this;
            this.input.addEventListener('keyup', () => {
                if (that.type === 'flat')
                    that.container.classList.remove('k-field-error-floating')
                else if (that.type === 'classic')
                    that.container.classList.remove('k-field-error');
            })*/
        }

        if(this.parameters.prefabName === "phone"){
            let that = this;
            "keyup change input blur autocompletechange".split(" ").forEach(function (e) {
                that.input.addEventListener(e, function (event) {
                    // Retrieving the input value with only numbers
                    let value = that.input.value;//.match(/\d/g).join('');
                    let onlyNumbers = value.match(/\d/g)
                    if(onlyNumbers === '' || onlyNumbers === null) {
                        that.input.value = '';
                        return;
                    }
                    onlyNumbers = onlyNumbers.join('');

                    if(onlyNumbers.length >= 7) {
                        that.input.value = onlyNumbers.replace(/^(\d{3})(\d{3})(\d{1,4}).*/, '($1) $2-$3');
                    }else if(onlyNumbers.length <= 3) {
                        that.input.value = onlyNumbers.replace(/^(\d{0,3}).*/, '($1');
                    } else if(onlyNumbers.length <= 6) {
                        that.input.value = onlyNumbers.replace(/^(\d{3})(\d{0,3}).*/, '($1) $2');
                    }
                })
            })
        }

        if(this.parameters.prefabName === "money") {
            let that = this;
            "keydown input autocompletechange".split(" ").forEach(function (e) {
                that.input.addEventListener(e, function (event) {
                    formatCurrency(that.input);
                    function formatCurrency(input, blur) {
                        var input_val = input.value;
                        if (input_val === "") { return; }
                        var original_len = input_val.length;
                        var caret_pos = input.selectionStart;

                        if (input_val.indexOf(".") >= 0) {
                            var decimal_pos = input_val.indexOf(".");
                            var left_side = input_val.substring(0, decimal_pos);
                            var right_side = input_val.substring(decimal_pos);
                            left_side = formatNumber(left_side);
                            right_side = formatNumber(right_side);
                            right_side = right_side.substring(0, 2);
                            input_val = "$" + left_side;
                        } else {
                            input_val = formatNumber(input_val);
                            input_val = "$" + input_val;
                        }
                        input.value = input_val;
                        var updated_len = input_val.length;
                        caret_pos = updated_len - original_len + caret_pos;
                        // input[0].setSelectionRange(caret_pos, caret_pos);
                    }
                    function formatNumber(n) {
                        // format number 1234567 to 1,234,567
                        return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                })
            })
        }
    }

    _addParameters() {
        if("prefabName" in this.parameters && "errors" in this.parameters) {
            this.prefab = this._getPrefab(this.parameters.prefabName, this.parameters.errors);
            this.type = _PREFAB;
        }

        if("validator" in this.parameters) {
            if(Array.isArray(this.parameters.validator)) {
                this.validatorsList = [];
                for(let it=0; it<this.parameters.validator.length; it++) {
                    let config = this.parameters.validator[it];
                    config.input_elem = this.container;
                    config.type = this.parameters.type;
                    this.validatorsList.push(validatorFactory(config));
                }
            }

            this.type = _VALIDATOR;
        }

        if("custom" in this.parameters) {
            this.type = _CUSTOM;
        }
    }

    isValid() {
        let useValidators = () => {
            let valid = true;
            // Check every validator and return false in case of failure (not valid input)
            let self = this;
            function checkAll(self) {
                if (Array.isArray(self.validatorsList)) {
                    for (let i = 0; i < self.validatorsList.length; i++) {
                        if (!self.validatorsList[i].isValid())
                            return false;
                    }
                }
                return true;
            }
            valid = checkAll(self);
            let notvalid = !valid;
            if(notvalid){
                this.container.addEventListener("focusout",()=>{
                    checkAll(self);
                })
            }
            return valid;
        };
        let usePrefab = () => {
            return this.prefab.isValid();
        };
        /* TODO: */
        let useCustom = () => {
            console.log("is custom")
        };

        switch(this.type){
            case _PREFAB:
                return usePrefab();
            case _VALIDATOR:
                console.log("using validators");
                return useValidators();
            case _CUSTOM:
                return useCustom();
        }
    }

    /**
     * @typedef {object} PrefabErrors
     * @type object
     * @property {String} [email_empty]
     * @property {String} [email_format]
     * @property {String} [phone_empty]
     * @property {String} [phone_format]
     * @property {String} [url_empty]
     * @property {String} [url_format]
     * @property {String} [money_empty]
     */
    /**
     *
     * @param {('email'|'phone'|'url'|'money')} prefabName
     * @param {PrefabErrors} errors
     * @returns {Boolean}
     * @private
     */
    _getPrefab(prefabName, errors){
        let container = this.container;
        let type = this.parameters.type;
        let recipes = {
            'email': function () {
                let email_empty = validatorFactory({
                    input_elem: container,
                    validation_func: isNotEmpty,
                    error_text: errors.email_empty,
                    error_events: "blur",
                    scrollUp: false,
                    type: type
                });
                let email_format = validatorFactory({
                    input_elem: container,
                    validation_func: validateEmail,
                    error_text: errors.email_format,
                    error_events: "blur",
                    scrollUp: false,
                    type: type
                });

                return {
                    isValid: function () {
                        "keyup change input blur autocompletechange".split(" ").forEach(function (e) {
                            container.addEventListener(e, function () {
                                if (!email_empty.isValid())
                                    return;
                                email_format.isValid();
                            });
                        });
                        if (email_empty.isValid()) {
                            return email_format.isValid();
                        }
                        return false;
                    }
                }
            }, //end of 'email'
            'url': function() {

            },
            'phone': function() {
                let that = this;

                let phone_empty = validatorFactory({
                    input_elem: container,
                    validation_func: (input) => {
                        return input.length > 0;
                    },
                    error_text: errors.phone_empty,
                    error_events: "blur",
                    scrollUp: false,
                    type: type
                });
                let phone_format = validatorFactory({
                    input_elem: container,
                    validation_func: (input) => {
                        let onlyNumbers = input.match(/\d/g);
                        return onlyNumbers.length === 10 ;
                    },
                    error_text: errors.phone_format,
                    error_events: "blur",
                    scrollUp: false,
                    type: type
                });
                return {
                    isValid : function(){
                        "keyup change input blur autocompletechange".split(" ").forEach(function (e) {
                            container.addEventListener(e, function () {
                                if (!phone_empty.isValid()) {
                                    return;
                                }
                                phone_format.isValid();
                            });
                        });
                        if(phone_empty.isValid())
                            return phone_format.isValid();
                        return false;
                    }
                }
            },
            'money': function() {
                let that = this;
                let money_empty = validatorFactory({
                    input_elem: container,
                    validation_func: isNotEmpty,
                    error_text: errors.money_empty,
                    error_events: "blur",
                    scrollUp: false,
                    type: type
                });
                return {
                    isValid : function(){
                        "keyup change input blur autocompletechange".split(" ").forEach(function (e) {
                            container.addEventListener(e, function () {
                                money_empty.isValid();
                            });
                        });
                        return money_empty.isValid();
                    }
                }
            }
        }; // end of recipes

        return recipes[prefabName]();
    }

}

let modalInstances = [];

const init = (background_rappers, modalParameters) => {
    if (background_rappers) {
        if (typeof background_rappers.length == 'undefined') {
            const htmlElement = background_rappers;
            const parameters = modalParameters;
            modalInstances = new KukunInput(htmlElement, parameters);
        } else {
            for (let i = 0; i < background_rappers.length; i++) {
                const htmlElement = background_rappers[i];
                let modalInstance = new KukunInput(htmlElement);
                modalInstances.push(modalInstance);
            }
        }
    }

    return modalInstances;
};


////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * @typedef {Object} ValidatorParams
 * @type Object
 * @property {HTMLElement|Element}      input_elem - Input container element
 * @property {function(String):Boolean} validation_func - A function which validates the input value with its own rules
 * @property {String}                   error_text - String with the respective error message to show/hide depending on validation result
 * @property {"classic"|"flat"}        type - Kukuns input type
 * @property {String}                   [error_events="keyup change input blur autocompletechange"] - Set of events to be listened in case of error to hide the error message.
 * @property {Boolean}                  [scrollUp=false] - Specify whether or not you want the window to scroll up in case of error.
 */

/**
 * Factory function to create validations for inputs and its respective error messages. The use of this factory
 * should reduce the amount of if-else statements and force the developer to follow this pattern for inputs and
 * forms.
 * @param {ValidatorParams} params
 * @returns {{isValid: (function(): boolean)}}
 * */
function validatorFactory(params) {
    let _error_events = (params.error_events == null)? "keyup change input autocompletechange" : params.error_events;
    let _scrollUp = (params.scrollUp == null)? false : params.scrollUp;
    let done = false;
    let input = params.input_elem.querySelector("input.k-input, textarea.k-input, input.k-s-input");
    let error = params.input_elem.querySelector(".k-error-msg, .k-s-error");
    let errorType;
    if(params.type === "flat")
        errorType = "k-field-error-floating";
    else if(params.type === "classic")
        errorType = "k-field-error";

    return {

        isValid : function() {
            if (params.validation_func(input.value)) {
                params.input_elem.classList.remove(errorType);
                return true;
            } else {
                error.textContent = params.error_text;
                params.input_elem.classList.add(errorType);

                let that = this;
                // Handling multiple events with the same function if not done
                if(!done) {
                    _error_events.split(" ").forEach(function (e) {
                        input.addEventListener(e, function () {
                            that.isValid();
                            //input_elem.unbind(_error_events);
                        }, false);
                    });
                    done = true;
                }
                if (_scrollUp)
                    params.input_elem.scrollIntoView({ behavior: 'smooth' });
                return false;
            }
        }
    }
}

/**
 *
 * @param {String} email
 * @returns {boolean}
 */
function validateEmail(email) {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return (email === '') ? true : re.test(email);
}

/**
 *
 * @param {String} val
 * @returns {boolean}
 */
function isNotEmpty(val) {
    return val !== '';
}

export {
    init
};